import { CustomerInformation } from './model/customer-information';
import { DadosProfissionaisComponent } from './../../../shared/dados-profissionais/dados-profissionais.component';
import { TelefoneCliente } from './../../ficha-cadastro/model/telefone-cliente';
import { DadosProfissionais } from './../../../shared/dados-profissionais/model/dados-profissionais';
import { Endereco as EnderecoCliente } from './../../ficha-cadastro/model/endereco-cliente';
import { Avalista as AvalistaFicha } from './../../ficha-cadastro/model/avalista';
import { FichaService } from './../../ficha-veiculo.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EnderecoTipo } from './model/endereco-tipo';
import { Endereco } from './model/endereco';
import { Proposta } from './model/proposta';
import { Avalista } from './model/avalista';

import { Subject } from 'rxjs';
import { Component, Input, OnInit, ViewChild, DoCheck } from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  FormBuilder,
  FormGroup,
  NgForm,
  ValidationErrors,
} from '@angular/forms';
import { FichaCadastro } from '../../ficha-cadastro/ficha-cadastro';
import { VeiculoEmSeuNome } from '../../ficha-cadastro/model/veiculo';
import { take } from 'rxjs/operators';
import { Referencia } from '../../ficha-cadastro/model/referencia';
import { Telefone } from '../../ficha-cadastro/model/telefone';
import { onlyDigits } from '../../../shared/helper/utils';

@Component({
  selector: 'app-modal-avalista',
  templateUrl: './ficha-modal-avalista.component.html',
  styleUrls: ['./ficha-modal-avalista.component.scss'],
})
export class FichaModalAvalistaComponent implements OnInit, DoCheck {
  @Input() fichaCadastro?: FichaCadastro;
  @Input() avalistasIncluidos?: Avalista[];
  @Input() index?: number;
  @Input() isPj?: boolean;

  @ViewChild('avalistaPpe', { static: true }) avalistaPpe: any;
  @ViewChild('avalistaNaoPpe', { static: true }) avalistaNaoPpe: any;
  @ViewChild('form', { static: false }) formAvalista: NgForm;
  @ViewChild('dadosProfissionaisAvalistaComponent', { static: true })
  dadosProfissionaisComponent: DadosProfissionaisComponent;

  avalista: Avalista = new Avalista();

  dataNascimentoValida;
  semRegistroPai = false;

  enderecoCorrespondencia: Endereco = new Endereco(EnderecoTipo.OUTRO);
  enderecoComercial: Endereco = new Endereco(EnderecoTipo.COMERCIAL);

  dataRange = {
    min: 18,
    max: 85,
    message: 'A idade deve ser entre 18 e 85 anos',
  };

  veiculoProprioForm: FormGroup;
  veiculoProprio: any;

  public onCloseModal: Subject<any> = new Subject();
  bsModalRef: BsModalRef;
  private customerInformation: CustomerInformation[] = [];
  private invalidPhones: string[] = [];

  public errorMessage: string;
  public errorMessageReference: string;
  private setted: boolean = false;
  public errorMessageEmail: string;
  constructor(
    bsModalRef: BsModalRef,
    private readonly fb: FormBuilder,
    private readonly fichaService: FichaService
  ) {
    this.bsModalRef = bsModalRef;
  }

  ngOnInit() {
    this.initFormVeiculo();
    this.initPpe();
    this.setCustomerInformation();
  }

  private setCustomerInformation() {
    if (this.isPj) {
      this.getCustomerInformations();
    }
  }

  ngDoCheck(): void {
    if (
      this.formAvalista &&
      this.formAvalista.controls['telefone-referencia'] &&
      this.setted === false
    ) {
      this.formAvalista.controls['celular-avalista'].setAsyncValidators(
        this.validCelphone('errorMessage')
      );
      this.formAvalista.controls['telefone-referencia'].setAsyncValidators(
        this.validCelphone('errorMessageReference')
      );
      this.formAvalista.controls['email-avalista'].setAsyncValidators(
        this.validEmail()
      );
      this.setted = true;
    }
  }

  initFormVeiculo() {
    this.veiculoProprioForm = this.fb.group({
      isVeiculoEmMeuNome: [false],
      veiculoPlaca: [null],
      isNaoSeiPlaca: [false],
      veiculoCategoria: [null],
      veiculoMarca: [null],
      veiculoAno: [null],
      veiculoModelo: [null],
      veiculoVersao: [null],
    });
  }

  onSubmit() {
    if (this.avalista.tipoEnderecoCorresp === '7') {
      this.avalista.addEndereco(this.enderecoCorrespondencia);
    }
    if (this.avalista.isEmpresa) {
      this.avalista.$enderecoComercial = this.enderecoComercial;
    }
    this.avalista.removeFieldsNull();

    const proposta: Proposta = new Proposta();
    proposta.avalistas[0] = this.avalista;
    if (!this.fichaCadastro.avalistasModal) {
      this.fichaCadastro.avalistasModal = [];
    }
    this.fichaCadastro.avalistasModal.push(
      this.getAvalistaFicha(this.avalista)
    );
    this.fichaCadastro.callRecoverDataCustomer();
    this.putDataClient();
    this.onCloseModal.next(proposta);
    this.bsModalRef.hide();
  }

  getAvalistaFicha(avalista: Avalista) {
    const avalistaFicha = new AvalistaFicha();
    avalistaFicha.grauParentescoCliente = avalista.grauParentesco;
    avalistaFicha.cpf = avalista.cpf;
    avalistaFicha.nome = avalista.nome;
    avalistaFicha.renda = avalista.renda;
    avalistaFicha.dataNascimento = avalista.dataNascimento;
    avalistaFicha.email = avalista.email;
    avalistaFicha.nomeMae = avalista.nomeMae;
    avalistaFicha.nomePai = avalista.nomePai;
    avalistaFicha.idTipoDocumento = avalista.idTipoDocumento;
    avalistaFicha.rgIe = avalista.rgIe;
    avalistaFicha.rgIeUf = avalista.naturalDeUf;
    avalistaFicha.rgIeData = avalista.rgIeDt;
    avalistaFicha.tipoEnderecoCorrespondencia = avalista.tipoEnderecoCorresp;
    avalistaFicha.rgIeEmissor = avalista.rgIeEmissor;
    avalistaFicha.idEstadoCivil = String(avalista.idEstadoCivil);
    avalistaFicha.idNacionalidade = avalista.idNacionalidade;
    avalistaFicha.naturalDe = avalista.naturalDe;
    avalistaFicha.naturalDeUf = avalista.naturalDeUf;
    avalistaFicha.clientePpe = avalista.clientePpe;
    avalistaFicha.valorPatrimonio = avalista.valorPatrimonio;
    avalistaFicha.dadoProfissional = DadosProfissionais.of(
      avalista.dadoProfissional.idClasseProfissional,
      avalista.dadoProfissional.idProfissao,
      avalista.dadoProfissional.nomeEmpresa,
      avalista.dadoProfissional.telefone.$dddNumero,
      new EnderecoCliente({
        idTipoEndereco: avalista.dadoProfissional.endereco
          ? avalista.dadoProfissional.endereco.idTipoEndereco
          : undefined,
        uf: avalista.dadoProfissional.endereco
          ? avalista.dadoProfissional.endereco.uf
          : undefined,
        cidade: avalista.dadoProfissional.endereco
          ? avalista.dadoProfissional.endereco.cidade
          : undefined,
        endereco: avalista.dadoProfissional.endereco
          ? avalista.dadoProfissional.endereco.endereco
          : undefined,
        bairro: avalista.dadoProfissional.endereco
          ? avalista.dadoProfissional.endereco.bairro
          : undefined,
        numero: avalista.dadoProfissional.endereco
          ? avalista.dadoProfissional.endereco.numero
          : undefined,
        complemento: avalista.dadoProfissional.endereco
          ? avalista.dadoProfissional.endereco.complemento
          : undefined,
        cep: avalista.dadoProfissional.endereco
          ? avalista.dadoProfissional.endereco.cep
          : undefined,
      })
    );
    avalistaFicha.avalistaReferencia = new Referencia(
      avalista.clienteReferencias[0].nome,
      avalista.clienteReferencias[0].idGrauRelacionamento,
      new Telefone(
        avalista.clienteReferencias[0].telefone.ddd,
        avalista.clienteReferencias[0].telefone.numero,
        '3',
        '1',
        '3'
      )
    );
    avalistaFicha.enderecos = new EnderecoCliente({
      idTipoEndereco: avalista.$enderecoResidencial.idTipoEndereco,
      uf: avalista.$enderecoResidencial.uf,
      cidade: avalista.$enderecoResidencial.cidade,
      endereco: avalista.$enderecoResidencial.endereco,
      bairro: avalista.$enderecoResidencial.bairro,
      numero: avalista.$enderecoResidencial.numero,
      complemento: avalista.$enderecoResidencial.complemento,
      cep: avalista.$enderecoResidencial.cep,
    });
    if (this.enderecoCorrespondencia) {
      avalistaFicha.enderecoCorrespondencia = new EnderecoCliente({
        idTipoEndereco: this.enderecoCorrespondencia.idTipoEndereco,
        uf: this.enderecoCorrespondencia.uf,
        cidade: this.enderecoCorrespondencia.cidade,
        endereco: this.enderecoCorrespondencia.endereco,
        bairro: this.enderecoCorrespondencia.bairro,
        numero: this.enderecoCorrespondencia.numero,
        complemento: this.enderecoCorrespondencia.complemento,
        cep: this.enderecoCorrespondencia.cep,
      });
    }
    avalistaFicha.telefones = new TelefoneCliente(
      avalista.telefones.map((tel) => ({
        categoria: {
          id: tel.idCategoria,
        },
        ddd: tel.ddd,
        telefone: tel.numero,
      }))
    );
    avalistaFicha.veiculoEmSeuNome = avalista.veiculoProprio;
    return avalistaFicha;
  }

  private putDataClient() {
    this.fichaService
      .putRecoverFullDataProposal(this.fichaCadastro.recoverData)
      .pipe(take(1))
      .subscribe();
  }

  onClickSemRegistroPai() {
    this.semRegistroPai = !this.semRegistroPai;

    if (!!this.semRegistroPai) {
      this.avalista.nomePai = 'NAO DECLARADO';
    } else {
      this.avalista.nomePai = '';
    }

    const el = document.getElementById('nome-pai-error-message');
    if (el) {
      el.remove();
    }
  }

  setAvalistaPpe(event) {
    const component = <HTMLInputElement>event.target;

    if (component.id === 'avalistaPpe') {
      this.avalistaNaoPpe.value = !component.checked;
      this.avalista.clientePpe = component.checked ? 'S' : 'N';
      return;
    }

    this.avalistaPpe.value = !component.checked;
    this.avalista.clientePpe = component.checked ? 'N' : 'S';
  }

  initPpe() {
    this.avalista.clientePpe = 'N';
    this.avalistaPpe.value = false;
    this.avalistaNaoPpe.value = true;
  }

  public getVeiculos(): VeiculoEmSeuNome[] {
    if (
      this.fichaCadastro.proposta &&
      this.fichaCadastro.proposta.avalista &&
      this.fichaCadastro.proposta.avalistas.length > 0
    ) {
      const avalistas = this.fichaCadastro.proposta.avalistas;
      return avalistas.map((m) => m.veiculoEmSeuNome);
    }
  }

  changeFormVeiculoEmSeuNome(event) {
    this.veiculoProprio = event.values;
    this.avalista.veiculoProprio = [this.veiculosFormatSimular()];
  }

  private veiculosFormatSimular() {
    // tslint:disable
    return (this.veiculoProprio = {
      placa: this.veiculoProprio.veiculoPlaca || '',
      uf: this.veiculoProprio.ufLicenciamento || '',
      categoria: this.veiculoProprio.veiculoCategoria
        ? { id: this.veiculoProprio.veiculoCategoria }
        : {},
      marca: this.veiculoProprio.veiculoMarca
        ? {
            id: this.veiculoProprio.veiculoMarca,
            descricao: undefined,
          }
        : {},
      anoModelo: this.veiculoProprio.veiculoAno || '',
      modelo: this.veiculoProprio.veiculoModelo
        ? {
            id: this.veiculoProprio.veiculoModelo,
            descricao: undefined,
          }
        : {},
      versao: this.veiculoProprio.veiculoVersao
        ? {
            id: this.veiculoProprio.veiculoVersao,
            descricao: undefined,
          }
        : {},
    });
    // tslint:enable
  }

  get isEmailInvalido() {
    return (
      (this.fichaCadastro._client.email &&
        this.fichaCadastro._client.email === this.avalista.email) ||
      this.avalistasIncluidos.some(
        (avalista) => avalista.email === this.avalista.email
      ) ||
      (this.fichaCadastro.proposta.avalistas &&
        this.fichaCadastro.avalistas.some(
          (avalista) => avalista.email === this.avalista.email
        ))
    );
  }

  get isCpfInvalido() {
    return (
      (this.avalista.$cpf &&
        this.avalista.$cpf === this.bsModalRef.content.cpfCliente) ||
      this.isCpfAvalistaInvalido
    );
  }

  get isCpfAvalistaInvalido() {
    if (this.avalistasIncluidos) {
      return (
        this.avalistasIncluidos.some(
          (avalista) => avalista.cpf === this.avalista.cpf
        ) ||
        (this.fichaCadastro.proposta.avalistas &&
          this.fichaCadastro.proposta.avalistas.some(
            (avalista) => avalista.cpf === this.avalista.cpf
          ))
      );
    }

    return false;
  }

  get isCelularInvalido() {
    return (
      (this.fichaCadastro._client.telefones.celular &&
        this.fichaCadastro._client.telefones.celular ===
          this.avalista.$celularAvalista) ||
      this.avalistasIncluidos.some((avalista) => {
        return avalista.telefones.some(
          (telefone) => telefone.$dddNumero === this.avalista.$celularAvalista
        );
      }) ||
      (this.fichaCadastro.proposta.avalistas &&
        this.fichaCadastro.proposta.avalistas.some((avalista) =>
          avalista.telefones.some(
            (tel) => tel.ddd + tel.numero === this.avalista.$celularAvalista
          )
        ))
    );
  }

  get isInvalidPhone() {
    return this.invalidPhones.includes(this.avalista.$celularAvalista);
  }

  get isValid() {
    if (
      this.dadosProfissionaisComponent &&
      this.dadosProfissionaisComponent.errorMessage
    ) {
      return false;
    }
    return (
      !this.isEmailInvalido &&
      !this.isCpfInvalido &&
      !this.isCelularInvalido &&
      !this.isInvalidPhone
    );
  }

  getCustomerInformations() {
    this.fichaService
      .getCustomerInformation(this.fichaCadastro.proposta.id)
      .pipe(take(1))
      .subscribe((customerInformations) => {
        customerInformations.forEach((customerInformation) => {
          const information = new CustomerInformation();
          information.setCustomerInformations(customerInformation);
          this.customerInformation.push(information);
        });
        this.invalidPhones = new CustomerInformation().getAllPhone(
          this.customerInformation
        );
      });
  }

  getDddAndCelular(value: string): { ddd: string; telefone: string } {
    if (!value || value === '') return { ddd: '', telefone: '' };
    const digits = onlyDigits(value);
    const ddd = digits.substring(0, 2);
    const telefone = digits.substring(2);
    return { ddd, telefone };
  }

  validCelphone(errorMessageName: string): AsyncValidatorFn {
    this[errorMessageName] = null;
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      if (!control.value || control.value.length === 0) {
        return Promise.resolve(null);
      }
      const dddCelular = this.getDddAndCelular(control.value);
      return this.fichaService
        .verifyCellPhone(dddCelular.ddd, dddCelular.telefone)
        .pipe(take(1))
        .toPromise()
        .then((res) => {
          if (res.status !== 'FAIL') {
            this[errorMessageName] = null;
            return null;
          }
          this[errorMessageName] = res.messages[0];
          return { genericErrorMessage: res.messages[0] };
        });
    };
  }

  clearErrorMessage(errorMessageName: string) {
    this[errorMessageName] = null;
  }

  validEmail(): AsyncValidatorFn {
    this.errorMessageEmail = null;
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      return this.fichaService
        .verifyEmail(control.value)
        .pipe(take(1))
        .toPromise()
        .then((res) => {
          if (res.status !== 'FAIL') {
            this.errorMessageEmail = null;
            return null;
          }
          this.errorMessageEmail = res.messages[0];
          return { genericErrorMessage: res.messages[0] };
        });
    };
  }
}
